import axios from 'axios'
import qs from 'qs'
import Fleet from '../interfaces/Fleet'

const axiosInstance = axios.create({
    baseURL: '/services/plugin-groovy/fleetTracking',
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
})

export const getLastTrips = (collection, span, uniqueID) => {
    return axiosInstance.get('/', {
        params: { collection, span, uniqueID },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        }
    })
}

//TODO: PASSAR COLLECTION
export const getSummary = (span, uniqueID, collection) => {
    return axiosInstance.get(`/resumo/${uniqueID}/?collection=${collection}`, {
        params: { span }
    })
}

export const getInfoLocation = (collection, span, uniqueID) => {
    return axiosInstance.get('/info-location', {
        params: { collection, span, uniqueID },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        }
    })
}

export const parseFleetFormat = ({ model, title, color, driver, license_plate, imei, asset: { name } }) => {
    const fleet: Fleet = {
        model,
        driver,
        license_plate,
        imei,
        name,
        keyMatch: imei,
        title
    }

    return fleet
}
